const STORAGE_KEY = "clairai_post_login_redirect";

const BLOCKED_PREFIXES = ["/login", "/callback"];

/**
 * Persist an in-app path so SSO / login can return the user
 * to Silence Alert / View Alert deep links from Teams.
 */
export function savePostLoginRedirect(path) {
  if (!path || typeof path !== "string") return;
  const cleaned = path.trim();
  if (!cleaned.startsWith("/") || cleaned.startsWith("//")) return;
  if (BLOCKED_PREFIXES.some((p) => cleaned === p || cleaned.startsWith(`${p}?`) || cleaned.startsWith(`${p}/`))) {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, cleaned);
  } catch (_) {
    /* ignore quota / private mode */
  }
}

export function peekPostLoginRedirect() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function consumePostLoginRedirect(fallback = "/dashboard") {
  let saved = "";
  try {
    saved = sessionStorage.getItem(STORAGE_KEY) || "";
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    /* ignore */
  }
  return sanitizePostLoginRedirect(saved, fallback);
}

export function sanitizePostLoginRedirect(path, fallback = "/dashboard") {
  if (!path || typeof path !== "string") return fallback;
  const cleaned = path.trim();
  if (!cleaned.startsWith("/") || cleaned.startsWith("//")) return fallback;
  if (BLOCKED_PREFIXES.some((p) => cleaned === p || cleaned.startsWith(`${p}?`) || cleaned.startsWith(`${p}/`))) {
    return fallback;
  }
  return cleaned;
}
